import { render, staticRenderFns } from "./ProjectServiceLocations.vue?vue&type=template&id=c8b596f4&scoped=true&"
import script from "./ProjectServiceLocations.vue?vue&type=script&lang=js&"
export * from "./ProjectServiceLocations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectServiceLocations.vue?vue&type=style&index=0&id=c8b596f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b596f4",
  null
  
)

export default component.exports